import { Box, Button, Divider, Grid, IconButton, Modal, Stack, TextField, Typography } from '@mui/material'
import React from 'react'
import { useTranslation } from 'react-i18next';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import { useForm } from '../../../../hooks';
import { useDispatch, useSelector } from 'react-redux';
import { Field } from '../../miProfile/Field';
import { DateInput } from '../../DateInput';
import { editFund } from '../../../helpers/fund';
import { unSelectInvestmentFunds } from '../../../../store/investmentFunds/investmentFundsSlice';
import { style } from '../../../../helpers/editStyle';

export const EditFunds = ({ setHidden, setReloadData }) => {

    const { t } = useTranslation('global');
    const { dataToAction } = useSelector(state => state.investmentFunds)

    const dispatch = useDispatch();
    const [formValues, handleInputChange, reset] = useForm(dataToAction);
    console.log("EditFunds mounted with dataToAction:", dataToAction);

    const { name, registrationDate, percentagePaid } = formValues;
    const percentageDistributed = formValues.percentageDistributed ?? 0;


    const handleCancel = () => {
        reset()
        dispatch(unSelectInvestmentFunds())
        setHidden(false)
    }
    const onSubmit = async (e) => {
        e.preventDefault();
        await editFund(formValues, t('funds.successEditMsg'), t('funds.errorEditMsg'))
        setReloadData(prevState => !prevState)
        setHidden(false)
    }

    return (
        <Modal
            open={true}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
            sx={{ zIndex: 9999 }}
        >
            <Box sx={style}>
                <Stack direction='row' justifyContent='space-between' alignItems='baseline' sx={{ height: '50px' }}>
                    <Typography color='primary' marginBottom='10px' variant='h5' fontWeight={700}>{t('funds.editFunds')}</Typography>
                    <IconButton color='primary' onClick={handleCancel}>
                        <CloseRoundedIcon />
                    </IconButton>
                </Stack>
                <form onSubmit={onSubmit} style={{ padding: '10px 5px', display: 'flex', flexDirection: 'column', justifyContent: 'space-around' }}>
                    <Stack sx={{ height: 'calc(70vh - 200px)', overflowY: 'auto', paddingBottom: '10px', paddingRight: '20px' }}>

                        <Grid container direction='row' width='100%' >
                            <Grid item xs={12} padding='0 5px'>
                                <Field name={name} title='name' handleInputChange={handleInputChange} translation='funds' isDisabled={true} />
                            </Grid>
                        </Grid>

                        <Grid container direction='row' width='100%' >
                            <Grid item xs={12} padding='0 5px'>
                                <DateInput name={registrationDate} title='registrationDate' handleInputChange={handleInputChange} required={true} />
                            </Grid>
                        </Grid>

                        <Grid container direction='row' width='100%' >
                            <Grid item xs={12} padding='0 5px'>
                                <Typography variant='overline' color='secondary'>{t('number.percentagePaid')}</Typography>
                                <TextField
                                    fullWidth
                                    name='percentagePaid'
                                    size="small"
                                    variant="outlined"
                                    value={percentagePaid}
                                    onChange={handleInputChange}
                                    required={true}
                                    type='number'
                                    InputProps={{ inputProps: { min: 0, max: 100, step: 'any' } }}
                                />
                            </Grid>
                        </Grid>

                        <Grid container direction='row' width='100%' >
                            <Grid item xs={12} padding='0 5px'>
                                <Typography variant='overline' color='secondary'>{t('number.percentageDistributed')}</Typography>
                                <TextField
                                    fullWidth
                                    name='percentageDistributed'
                                    size="small"
                                    variant="outlined"
                                    value={percentageDistributed}
                                    onChange={handleInputChange}
                                    required={true}
                                    type='number'
                                    InputProps={{ inputProps: { min: 0, max: 100, step: 'any' } }}
                                />
                            </Grid>
                        </Grid>

                    </Stack>

                    <Stack sx={{ heigth: '80px' }}>
                        <Divider sx={{ margin: '30px 0px 15px 0px' }} />

                        <Grid container direction='row' width='100%' >
                            <Grid item xs={12} md={6} padding='0 5px'>
                                <Button fullWidth onClick={handleCancel} variant="text">{t("createPassword.cancelButton")}</Button>
                            </Grid>
                            <Grid item xs={12} md={6} padding='0 5px'>
                                <Button fullWidth type='submit' variant="contained">{t("createPassword.principalButton")}</Button>
                            </Grid>
                        </Grid>
                    </Stack>
                </form>

            </Box>
        </Modal>
    )
}